import { Label } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import InvoiceActionMenu from "../../../components/InvoiceActionMenu";
import InvoiceLink from "../../../components/InvoiceLink";
import useInvoiceStatusTranslations from "../../../hooks/useInvoiceStatusTranslations";
import useInvoiceTypeTranslations from "../../../hooks/useInvoiceTypeTranslations";
import { invoiceStatusColors } from "../../../utils/invoiceStatusColors";

export default function useInvoiceTableColumns() {
	const { t } = useTranslation();

	const invoiceStatusTranslations = useInvoiceStatusTranslations();
	const invoiceTypeTranslations = useInvoiceTypeTranslations();

	return [
		{
			id: "invoiceNumber",
			Header: t("invoice", "Invoice"),
			Cell: ({ row }) => <InvoiceLink invoice={row} />,
		},
		{
			id: "orderId",
			Header: t("salesOrder", "Sales order"),
			Cell: ({ value }) => <Link to={`../../finance/sales/${value}`}>{value}</Link>,
		},
		{
			id: "created",
			Header: t("created", "Created"),
			Cell: ({ value }) => value?.toDate?.()?.toLocaleDateString() || "",
		},
		{
			id: "dueDate",
			Header: t("dueDate", "Due date"),
			Cell: ({ value }) => value?.toDate?.()?.toLocaleDateString() || "",
		},
		{
			id: "type",
			Header: t("type", "Type"),
			Cell: ({ value }) => invoiceTypeTranslations[value],
		},
		{
			id: "status",
			Header: t("status", "Status"),
			Cell: ({ value }) => <Label color={invoiceStatusColors[value]}>{invoiceStatusTranslations[value]}</Label>,
		},
		{
			id: "menu",
			Cell: ({ row }) => <InvoiceActionMenu invoice={row} />,
		},
	];
}
